import SharedCustomerSimpleView from './shared-customer-simple-view'

export default SharedCustomerSimpleView